import { render } from "./Home.vue?vue&type=template&id=6880f4cc&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=6880f4cc&lang=scss&scoped=true"

import exportComponent from "/Users/mac/lavide-pro2/lavideo-pages/noka/lwInno.com /node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6880f4cc"]])

export default __exports__